import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ReportedResource } from '../../types/report';
import { ReportForm } from './ReportForm';

interface ReportModalProps {
    isOpen: boolean;
    onClose: () => void;
    reportedResource: ReportedResource;
    onReportSubmitted?: (success: boolean) => void;
}

export const ReportModal: React.FC<ReportModalProps> = ({
    isOpen,
    onClose,
    reportedResource,
    onReportSubmitted
}) => {
    const handleReportSubmit = (success: boolean) => {
        onReportSubmitted?.(success);
        if (success) {
            onClose();
        }
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-3 sm:p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-sm sm:max-w-2xl lg:max-w-3xl transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 shadow-xl transition-all">
                                <div className="absolute right-2 sm:right-4 top-2 sm:top-4">
                                    <button
                                        type="button"
                                        className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500"
                                        onClick={onClose}
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden="true" />
                                    </button>
                                </div>

                                <div className="max-h-[90vh] overflow-y-auto scrollbar-hide">
                                    <ReportForm
                                        reportedResource={reportedResource}
                                        onSubmit={handleReportSubmit}
                                        onCancel={onClose}
                                    />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};